"use strict";

var _interopRequireDefault = require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.number.constructor");

var _vueCountTo = _interopRequireDefault(require("vue-count-to"));

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  name: "CardInfoV3",
  components: {
    CountTo: _vueCountTo.default
  },
  props: {
    info: Object,
    cardKey: Number
  },
  data: function data() {
    return {
      isFocus: false
    };
  },
  computed: {
    svg: function svg() {
      return require("../../../assets/icons/".concat(this.info.icon.icon, ".svg"));
    }
  }
};
exports.default = _default;